<template>
  <div>
    <md-card class="card" style="margin: 1rem;">
      <md-card-content>
        <md-layout md-gutter>
          <md-layout style="position: absolute;">
            <md-button
              class="md-raised md-primary md-button-color heght-1px"
              style=" margin-top"
              @click="previousContainerView"
            >&laquo; Back</md-button>
          </md-layout>
          <!-- <md-layout md-flex="30"></md-layout> -->
          <md-layout class="justify-content-center">
            <h2>{{editVar.FormVal}} Container Details</h2>
          </md-layout>
        </md-layout>

        <hr class="hr-s">

        <md-layout md-gutter class="justify-content-center">
          <!-- <md-layout md-flex="5"></md-layout> -->
          <md-layout md-flex="45">
            <md-layout md-flex="100">
              <label>Container Size-Type (eg...40-COLLAPSIBLE FLAT RACK)</label>
              <b-form-input :formatter="capitalizeAll"
                id="containerType"
                name="containerType"
                v-model="containerDetail.containerType"
              ></b-form-input>
            </md-layout>
            <span class="error" v-if="!containerDetail.containerType">{{containerTypeError}}</span>
          </md-layout>

          <!-- <md-layout md-flex="5"></md-layout> -->

          <md-layout md-flex="45" class="ml-3">
            <md-layout md-flex="100">
              <label>Max Payload (in Kg)</label>
              <b-form-input :formatter="capitalizeAll" id="maxPayload" name="maxPayload" v-model="containerDetail.maxPayload"></b-form-input>
            </md-layout>
          </md-layout>
        </md-layout>

        <hr>

        <md-layout md-gutter>
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="30">
            <label>
              <u>Internal Dimension</u>
            </label>
          </md-layout>
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="20"></md-layout>
        </md-layout>

        <md-layout md-gutter>
          <md-layout md-flex="5"></md-layout>

          <md-layout md-flex="20">
            <md-layout md-flex="100">
              <label>Length (in meters)</label>
              <b-form-input :formatter="capitalizeAll"
                type="number"
                min="0"
                id="internalDimLength"
                name="internalDimLength"
                v-model="containerDetail.internalDimLength"
                @keyup="findArea()"
              ></b-form-input>
            </md-layout>
            <span class="error" v-if="!containerDetail.internalDimLength">{{internalDimLengthError}}</span>
          </md-layout>
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="20">
            <md-layout md-flex="100">
              <label>Width (in meters)</label>
              <b-form-input :formatter="capitalizeAll"
                type="number"
                min="0"
                id="internalDimWidth"
                name="internalDimWidth"
                v-model="containerDetail.internalDimWidth"
                @keyup="findArea()"
              ></b-form-input>
            </md-layout>
            <span class="error" v-if="!containerDetail.internalDimWidth">{{internalDimWidthError}}</span>
          </md-layout>
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="20">
            <md-layout md-flex="100">
              <label>Height (in meters)</label>
              <b-form-input :formatter="capitalizeAll"
                type="number"
                min="0"
                id="internalDimHeight"
                name="internalDimHeight"
                v-model="containerDetail.internalDimHeight"
              ></b-form-input>
            </md-layout>
          </md-layout>

          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="15 ">
            <md-layout md-flex="100">
              <label>Area(in meters)</label>
              <b-form-input :formatter="capitalizeAll"
                type="number"
                min="0"
                id="internalDimHeight"
                name="internalDimHeight"
                v-model="containerDetail.area"
                disabled
              ></b-form-input>
            </md-layout>
            <span class="error" v-if="!containerDetail.area">{{areaError}}</span>
          </md-layout>
        </md-layout>

        <md-layout md-gutter>
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="30"></md-layout>
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="20"></md-layout>
        </md-layout>
        <hr>
        <md-layout md-gutter>
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="30">
            <label>
              <u>Select Other Dimensions</u>
            </label>
          </md-layout>
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="20"></md-layout>
        </md-layout>

        <md-layout md-gutter>
          <md-layout md-flex="5"></md-layout>

          <md-layout md-flex="30">
            <md-layout md-flex="100">
              <label for="selectDimension">Select Dimension</label>
              <model-list-select
                :list="otherDimensionList"
                v-model="containerDetail.otherDimension"
                option-value="otherDimensionV"
                option-text="otherDimensionT"
                placeholder="Select Other Dimension"
              ></model-list-select>
              <!-- <md-select
                name="otherDimension"
                id="otherDimension"
                v-model="containerDetail.otherDimension"
              >
                <md-option value>Select Other Size</md-option>
                <md-option value="Door">Door</md-option>
                <md-option value="Roof">Roof</md-option>
                <md-option value="OutSide">OutSide</md-option>
              </md-select>-->
            </md-layout>
          </md-layout>
        </md-layout>

        <md-layout md-gutter v-if="containerDetail.otherDimension=='Door'">
          <md-layout md-flex="5"></md-layout>

          <md-layout md-flex="20">
            <md-layout md-flex="100">
              <label>Width (in meters)</label>
              <b-form-input :formatter="capitalizeAll" id="doorWidth" name="doorWidth" v-model="containerDetail.doorWidth"></b-form-input>
            </md-layout>
          </md-layout>
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="20">
            <md-layout md-flex="100">
              <label>Height (in meters)</label>
              <b-form-input :formatter="capitalizeAll" id="doorHeight" name="doorHeight" v-model="containerDetail.doorHeight"></b-form-input>
            </md-layout>
          </md-layout>
          <md-layout md-flex="20"></md-layout>
        </md-layout>

        <md-layout md-gutter v-if="containerDetail.otherDimension=='Roof'">
          <md-layout md-flex="5"></md-layout>

          <md-layout md-flex="20">
            <md-layout md-flex="100">
              <label>Length (in meters)</label>
              <b-form-input :formatter="capitalizeAll" id="roofLength" name="roofLength" v-model="containerDetail.roofLength"></b-form-input>
            </md-layout>
          </md-layout>
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="20">
            <md-layout md-flex="100">
              <label>Height (in meters)</label>
              <b-form-input :formatter="capitalizeAll" id="roofHeight" name="roofHeight" v-model="containerDetail.roofHeight"></b-form-input>
            </md-layout>
          </md-layout>
          <md-layout md-flex="20"></md-layout>
        </md-layout>

        <md-layout md-gutter v-if="containerDetail.otherDimension=='OutSide'">
          <md-layout md-flex="5"></md-layout>

          <md-layout md-flex="20">
            <md-layout md-flex="100">
              <label>Length (in meters)</label>
              <b-form-input :formatter="capitalizeAll"
                id="outSideLength"
                name="outSideLength"
                v-model="containerDetail.outSideLength"
              ></b-form-input>
            </md-layout>
          </md-layout>
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="20"></md-layout>
          <md-layout md-flex="20"></md-layout>
        </md-layout>
        <hr>

        <md-layout md-gutter>
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="30">
            <label>
              <u>Select Capacity</u>
            </label>
          </md-layout>
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="20"></md-layout>
        </md-layout>

        <md-layout md-gutter>
          <md-layout md-flex="5"></md-layout>

          <md-layout md-flex="30">
            <md-layout md-flex="100">
              <label for="selectCapacity">Select Capacity</label>
              <model-list-select
                :list="selectCapacityList"
                v-model="containerDetail.selectCapacity"
                option-value="selectCapacityV"
                option-text="selectCapacityT"
                placeholder="Select Capacity"
              ></model-list-select>
              <!-- <md-select
                name="selectCapacity"
                id="selectCapacity"
                v-model="containerDetail.selectCapacity"
              >
                <md-option value>Select Capacity</md-option>
                <md-option value="cubicCapacity">Cubic Capacity</md-option>
                <md-option value="Inside">Inside</md-option>
              </md-select>-->
            </md-layout>
          </md-layout>
        </md-layout>
        <md-layout md-gutter v-if="containerDetail.selectCapacity=='cubicCapacity'">
          <md-layout md-flex="5"></md-layout>

          <md-layout md-flex="20">
            <md-layout md-flex="100">
              <label>Cubic Capacity</label>
              <b-form-input :formatter="capitalizeAll"
                id="cubicCapacity"
                name="cubicCapacity"
                v-model="containerDetail.cubicCapacity"
              ></b-form-input>
            </md-layout>
          </md-layout>
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="20"></md-layout>
          <md-layout md-flex="20"></md-layout>
        </md-layout>
        <md-layout md-gutter v-if="containerDetail.selectCapacity=='Inside'">
          <md-layout md-flex="5"></md-layout>

          <md-layout md-flex="20">
            <md-layout md-flex="100">
              <label>Length (in meters)</label>
              <b-form-input :formatter="capitalizeAll"
                id="insideLength"
                name="insideLength"
                v-model="containerDetail.insideLength"
              ></b-form-input>
            </md-layout>
          </md-layout>
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="20">
            <md-layout md-flex="100">
              <label>Width (in meters)</label>
              <b-form-input :formatter="capitalizeAll"
                id="insideWidth"
                name="insideWidth"
                v-model="containerDetail.insideWidth"
              ></b-form-input>
            </md-layout>
          </md-layout>
          <md-layout md-flex="20"></md-layout>
        </md-layout>
        <hr class="hr-border">

        <md-layout md-gutter class="mrgtop-button justify-content-center">
          <!-- <md-layout md-flex="40"></md-layout> -->
          <md-button
            class="md-raised md-primary md-button-color mrgtop-2per"
            @click="addVehicleSize"
            id="addButtonLoader"
          >{{editVar.Inputval}}</md-button>
          <md-spinner md-indeterminate id="loader" style="display:none"></md-spinner>
        </md-layout>
      </md-card-content>
    </md-card>

    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
      @close="onClose"
    ></md-dialog-alert>
  </div>
</template>


<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
import { URL_BASE, URL_BASE_DOC } from "../../../helper/constant.js";
import { DateFormat, selectDateFormat} from "../../../helper/filters";
import { globalPermissionStatus } from "../../../helper/collection";

export default {
  beforeMount() {
    if (
      this.$sessionsStorage.get("loginId") != undefined &&
      this.$sessionsStorage.get("loginId") != ""
    ) {
      this.$store.dispatch("setCurrentRoute", "/container/containerType");
      if (globalPermissionStatus("containerMaster") != "Disabled") {
        this.$sessionsStorage.set(
          "PermissionStatus",
          globalPermissionStatus("containerMaster")
        );
      } else {
        this.$router.push({
          path: "/dashboard"
        });
      }
      if (
        this.$sessionsStorage.get("editContainerId") != "" &&
        this.$sessionsStorage.get("editContainerId") != undefined
      ) {
        this.viewEditContainer();
      }
    } else {
      this.$router.push({
        path: "/Login/"
      });
    }
  },
  data() {
    return {
      alert: {
        content:
          this.$sessionsStorage.get("editContainerId") != "" &&
          this.$sessionsStorage.get("editContainerId") != undefined
            ? "Updated Succesfully"
            : "Added Succesfully",
        ok: "ok"
      },
      otherDimensionList: [
        {
          otherDimensionV: "Door",
          otherDimensionT: "Door"
        },
        {
          otherDimensionV: "Roof",
          otherDimensionT: "Roof"
        },
        {
          otherDimensionV: "OutSide",
          otherDimensionT: "OutSide"
        }
      ],

      selectCapacityList: [
        {
          selectCapacityV: "cubicCapacity",
          selectCapacityT: "Cubic Capacity"
        },
        {
          selectCapacityV: "Inside",
          selectCapacityT: "Inside"
        }
      ],

      containerDetail: {
        containerTypeId: "",
        containerType: "",
        internalDimLength: "",
        internalDimWidth: "",
        internalDimHeight: "",
        otherDimension: "",
        doorWidth: "",
        doorHeight: "",
        roofLength: "",
        roofHeight: "",
        outSideLength: "",
        selectCapacity: "",
        cubicCapacity: "",
        insideLength: "",
        insideWidth: "",
        maxPayload: "",
        area: ""
      },
      editVar: {
        Inputval:
          this.$sessionsStorage.get("editContainerId") != "" &&
          this.$sessionsStorage.get("editContainerId") != undefined
            ? "Update"
            : "Add",
        FormVal:
          this.$sessionsStorage.get("editContainerId") != "" &&
          this.$sessionsStorage.get("editContainerId") != undefined
            ? "Update"
            : "New"
      },

      vehicleSizeMaster: [
        {
          SrNo: "1"
          //  "vehicleSize":"1",
          //  "icon":"delete"
        }
      ],
      validate: true,
      containerTypeError: "",
      internalDimLengthError: "",
      internalDimWidthError: "",
      areaError: ""
    };
  },
  filters: {
    moment(date) {
      return DateFormat(date)
    }
  },

  mounted() {
    //this.JqueryFun()
  },
  beforeDestroy() {
    this.$sessionsStorage.set("editContainerId", "");
  },
  destroyed() {},
  components: {
    DatePicker,
    ModelListSelect
  },
  computed: {},
  methods: {
    findArea() {
      this.containerDetail.area =
        parseFloat(this.containerDetail.internalDimLength) *
        parseFloat(this.containerDetail.internalDimWidth);
    },
    JqueryFun() {
      return $(function() {
        return $("#vehicleSizenew").DataTable();
      });
    },
    onClose(type) {
      this.$router.push({
        path: "/container/viewContainerType"
      });
    },

    previousContainerView() {
      this.$router.push({
        path: "/container/viewContainerType"
        // params:{
        //   "userId":res.data.Id,
        // }
      });
    },

    validateAddVehicleSizeForm() {
      let validate_new = true;

      if (this.containerDetail.containerType == "") {
        $("#containerType").focus();
        this.containerTypeError = "Enter container type";
        validate_new = false;
      }
      if (this.containerDetail.internalDimLength == "") {
        $("#internalDimLength").focus();
        this.internalDimLengthError = "Enter Length";
        validate_new = false;
      }
      if (this.containerDetail.internalDimWidth == "") {
        $("#internalDimWidth").focus();
        this.internalDimWidthError = "Enter width";
        validate_new = false;
      }
      // if (this.containerDetail.area == "") {
      //   $("#area").focus();
      //   this.areaError = "Enter area";
      //   validate_new = false;
      // }

      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },

    addVehicleSize() {
      this.validateAddVehicleSizeForm();
      if (this.validate != false) {
        $("#addButtonLoader").css("display", "none");
        $("#loader").css("display", "block");
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Master/addContainerType.php`,
          data: JSON.stringify(this.containerDetail),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };

        axios(options)
          .then(result => {
            $("#addButtonLoader").css("display", "block");
            $("#loader").css("display", "none");
            this.$refs["addPop"].open();
          })
          .catch(error => {});
      }
    },

    viewEditContainer() {
      let edit_Driver = {
        edit: "edit",
        containerTypeId: this.$sessionsStorage.get("editContainerId")
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Master/viewEditContainer.php`,
        data: JSON.stringify(edit_Driver),

        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };

      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            Object.keys(this.containerDetail).map(x => {
              this.containerDetail[x] = data.editDriver[0][x] || "";

              // this.viewEditClientDetail = data.editClient;
              //  console.log("fsf",data.truckSizeDetails)
            });
          }
        })
        .catch(error => {});
    }
  }
};
</script>
<style>
.md-direction-bottom-right {
  width: 30% !important;
}
.mrgtop-2per {
  margin-top: 1%;
}
.mrgtop-5px {
  margin-top: 0px;
}
.center {
  text-align: center;
}
.heght-1px {
  height: 1px;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}
.md-button-color {
  background-color: #002b49 !important;
  transition: all 0.2ms;
}

.md-button-color-toggle {
  background-color: #002b49 !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
</style>


// WEBPACK FOOTER //
// containerType.vue?2f89a989